import {
    getCategoryAndBrandsApiEndpoint,
    getProductsByBrandOrSuperCategoryApiEndpoint,
    getValidatedProductsEndpoint,
    getPricesForItemsEndpoint,
} from 'src/pages/more/pages/productGuide/redux/services/endpoints';
import axios from 'src/api/Api';

// Re-export endpoints for use in sagas
export {
    getCategoryAndBrandsApiEndpoint,
    getProductsByBrandOrSuperCategoryApiEndpoint,
    getValidatedProductsEndpoint,
    getPricesForItemsEndpoint,
};

export const getProductsGuideDataService = async () => {
    const response = await axios.get('productsGuide');
    return response ? response.data : {};
};

export const getValidateProductsDataServices = async (queryParams) => {
    const response = await axios.get(
        getValidatedProductsEndpoint(queryParams)
    );
    return response ? response.data : {};
};

export const getPricesForItemsDataService = async (queryParams) => {
    const response = await axios.get(
        getPricesForItemsEndpoint(queryParams)
    );
    return response ? response.data : {};
};

export const getProductsByBrandOrSuperCategoryDataService = async (
    queryParams
) => {
    const response = await axios.get(
        getProductsByBrandOrSuperCategoryApiEndpoint(queryParams)
    );
    return response ? response.data : {};
};

export const getCategoryAndBrandsDataService = async (baseSiteId, isMastOrder) => {
    const response = await axios.get(
        getCategoryAndBrandsApiEndpoint(baseSiteId,isMastOrder)
    );
    return response ? response.data : {};
};